var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[_c('v-textarea',{attrs:{"label":_vm.campo.rotulo,"value":_vm.value,"hint":_vm.campo.ajuda,"clearable":"","autoGrow":"","filled":"","rules":_vm.validadores},on:{"input":_vm.updateValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }